import axios from 'axios';

export default axios.create({
  baseURL: 'https://react-quiz-14e28.firebaseio.com/',
});
